"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleCustomComponent = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("../../components");
const ExampleCustomComponent = () => {
  return react_1.default.createElement(components_1.ReactifySearchProvider, {
    mode: "search",
    shopifyPermanentDomain: "usereactify-demo.myshopify.com",
    additionalComponentIds: ["SensorSpecialProduct"]
  }, react_1.default.createElement(components_1.CustomComponent, {
    componentId: "SensorSpecialProduct",
    customQuery: () => ({
      query: {
        match: {
          product_type: "Special Product"
        }
      }
    })
  }));
};
exports.ExampleCustomComponent = ExampleCustomComponent;